var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 20,
    viewBox: "0 0 45 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-short"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1453",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7172 1.05395C34.9674 0.803093 35.3072 0.662109 35.6615 0.662109C36.0158 0.662109 36.3556 0.803093 36.6058 1.05395L44.6082 9.05639C44.8591 9.30662 45.0001 9.64638 45.0001 10.0007C45.0001 10.355 44.8591 10.6948 44.6082 10.945L36.6058 18.9474C36.0843 19.4689 35.2387 19.4689 34.7172 18.9474C34.1957 18.4259 34.1957 17.5804 34.7172 17.0588L41.7772 10.0001L34.7172 2.94134C34.4664 2.69111 34.3254 2.35136 34.3254 1.99705C34.3254 1.64273 34.4664 1.30298 34.7172 1.05276V1.05395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 1454",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.573975 10.0002C0.573975 9.26364 1.86011 8.6665 3.4466 8.6665H40.7907C42.3773 8.6665 43.6634 9.26364 43.6634 10.0002C43.6634 10.7369 42.3773 11.334 40.7907 11.334H3.4466C1.86011 11.334 0.573975 10.7369 0.573975 10.0002Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.794720e7942c76013912e6c1369f46de.svg";
export { ForwardRef as ReactComponent };